export default class Location {
  constructor(code) {
    this.code = code
    this.city = ""
    this.state = ""
    this.country = ""
    this.gantRanking = 0
    this.utcOffsetHours = 0
    this.cityCode = code
    this.countryName = ""
    this.classification = 1
    this.airportName = ""
    this.detailedName = ""
    this.subType = "AIRPORT"
    this.geocode = null
    this.airportAdded = true
    this.altered = true
  }
} 